export default __webpack_public_path__ + "assets/Land.0fed30a5.png";